(function ($, Drupal) {
    Drupal.behaviors.paginator = {
        attach: function (context, settings) {
            const pathSearch = document.querySelector(".path-search");
            const notFound = document.querySelector(".not-found");
            if (!pathSearch) return;

            let paginator = pathSearch.querySelector(".pagination");
            
            if (!paginator && !notFound) {
                console.warn("No se encontraron resultados");
                setTimeout(() => location.reload(), 500); // 🔹 Evita bucles infinitos con un retraso
                return;
               
            }
            if (!paginator) {
                return;
                
            }

            const pageItems = Array.from(paginator.querySelectorAll(".page-item"));
            if (pageItems.length === 0) return; // 🔹 No hay elementos de paginación

            const lastArrow = pageItems[pageItems.length - 1];
            const pages = pageItems.slice(2, -2); // 🔹 Filtra los elementos de paginación
            
            function updatePagination() {
                let activeIndex = pages.findIndex((item) => item.classList.contains("active"));

                if (activeIndex === -1) {
                    activeIndex = pageItems.findIndex(item => item.classList.contains("active")) || 1;
                }

                if (lastArrow.classList.contains("active")) {
                    activeIndex = pageItems.length - 3;
                }

                pages.forEach((item, index) => {
                    item.style.display = Math.abs(index - activeIndex) >= 2 ? "none" : "";
                });
            }

            updatePagination();
        },
    };
})(jQuery, Drupal);
